export default __webpack_public_path__ + "static/media/auth-video.7007b6ee.mp4";